import { useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { gql } from 'graphql-request'
import { useQuery } from '@hooks/graphql'

const CLASSROOM_CONSENT_QUERY = gql`
  query classroomResearchConsent($id: ID!) {
    classroom(id: $id) {
      id
      name
      research
      researchConsentingOnly
      classroomEnrollment {
        researchConsent
      }
    }
  }
`

const useResearchConsent = (classroomId) => {
  const navigate = useNavigate()
  const location = useLocation()
  
  const {
    isLoading,
    data: { classroom } = {},
    refetch
  } = useQuery({
    queryKey: ['classroom-consent', classroomId],
    gqlQuery: CLASSROOM_CONSENT_QUERY,
    variables: { id: classroomId },
    enabled: !!classroomId,
    staleTime: 0,
    cacheTime: 0,
  })

  useEffect(() => {
    if (isLoading || !classroom) return
    
    if (classroom.research) {
      const { researchConsent } = classroom.classroomEnrollment || {}
      if (researchConsent === null) {
        navigate(`/students/classrooms/${classroomId}/research-consent?redirect_to=${location.pathname}`, { replace: true })
      } else if (researchConsent === false && classroom.researchConsentingOnly) {
        navigate(`/students/classrooms/${classroomId}/research-consent/blocked`, { replace: true })
      }
    }
  }, [classroom, classroomId, isLoading, navigate, location.pathname])

  return { isLoading, classroom, refetch }
}

export default useResearchConsent
